<!--
 * @FileDescription: 售价设置（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-06-29（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">
          <div class="price-title">商品售价</div>
          <a-table :columns="columns"
                   :dataSource="dataSource"
                   bordered
                   :pagination="false"
                   class="price-table"
          >
              <template slot="data2" slot-scope="text, record">
                  <span style="padding-left: 10px">
                      <span v-if="isEmpty(record.showName)">{{record.fieldName}}</span>
                      <span v-else>{{text}}</span>
                  </span>
              </template>
              <template slot="data3" slot-scope="text, record">
                  <span>零售价*
                      <span v-if="isEmpty(record.discount)">100</span>
                      <span v-else>{{text}}</span>
                      %
                  </span>
              </template>
              <template slot="data4" slot-scope="text, record">
                  <span class="table-name" @click="onClickName(record)" v-has="'commodity_price_operation'">设置</span>
              </template>
          </a-table>
      </div>
      <a-modal :title="title" v-model="visible" @ok="handleOk" class="price-modal"  >
          <a-form :form="form"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 16 }"
          >
              <a-form-item label="售价名称">
                  <a-input placeholder="请输入名称"
                           v-decorator="['showName', { rules: [{ required: false, message: '请输入名称' }] }]" />
              </a-form-item>
              <a-form-item label="折扣比列">
                  <a-input-number placeholder="请输入折扣比列"
                           :min="0"
                           :max="100"
                           class="dis-input"
                           v-decorator="['discount', { rules: [{ required: false, message: '请输入折扣比列' }] }]" />% * 零售价
              </a-form-item>
          </a-form>
      </a-modal>
  </div>
</template>
<script>
import {priceList,priceUpdate} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import pick from 'lodash.pick'
export default {
    mixins:[mixins],
    data(){
        return{
            columns:[
                {
                    title: '',
                    key: 'fieldName',
                    align: 'center',
                    dataIndex: 'fieldName',
                },
                {
                    title: '售价名称',
                    key: 'showName',
                    width:380,
                    dataIndex: 'showName',
                    scopedSlots: { customRender: 'data2' },
                },
                {
                    title: '折扣比例',
                    key: 'discount',
                    width:380,
                    dataIndex: 'discount',
                    scopedSlots: { customRender: 'data3' },
                },
                {
                    title: '操作',
                    dataIndex: 'data4',
                    align:'center',
                    scopedSlots: { customRender: 'data4' },
                },
            ],
            dataSource:[],
            visible:false,
            title:'售价等级设置',
            form:this.$form.createForm(this),
            model:{},
        }
    },
    watch: {
    },
    mounted () {
        this.getList()
    },
    created () {

    },
    components: {
    },
    methods: {
        /**
        * @description: 售价列表（方法描述）
        */
        getList(){
            this.$store.state.isLoding = true
            let data = {
                companyStoreId:this.$store.state.shopId,
                company_store_id:this.$store.state.shopId
            }
            data =   this.$qs.stringify(data)
            priceList(data,{}).then(res => {
                if (res.success) {
                    res.result.forEach((item)=>{
                        item.isCheck = false
                        item.isCheck1 = false
                    })
                    this.dataSource = res.result
                    this.$store.state.isLoding = false
                }
            })
        },
        /**
        * @description: 打开设置价格弹框
        */
        onClickName(record,index){
            this.model = {}
            this.form = this.$form.createForm(this)
            if(this.isEmpty(record.showName)){
                this.$set(record,'showName',record.fieldName)
            }
            if(this.isEmpty(record.discount)){
                this.$set(record,'discount',100)
            }
            this.model = Object.assign({},record)
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model,'showName','discount','id'))
            });
            this.visible = true
        },
         /**
        * @description: 设置价格
        */
        handleOk(){
            this.form.validateFields((err, values) => {
                if(!err){
                    console.log(values)
                    priceUpdate({
                        companyStoreId:this.$store.state.shopId,
                        companyId:this.$store.state.companyId,
                        discount:values.discount,
                        fieldName:this.model.fieldName,
                        showName:values.showName,
                        id:this.model.id
                    },{}).then((res)=>{
                        if(res.success){
                            this.getList()
                            this.visible = false
                            this.$message.success(res.logMessage)
                        }else{
                            this.$message.warn(res.logMessage)
                        }
                    })
                }
            })
        },
    },

}
</script>
<style lang="scss">
    .price-table{
        .ant-table-thead > tr > th, .ant-table-tbody > tr > td{
            padding: 10px 16px;
        }
        .ant-table-tbody > tr > td{
            height: 59px;
        }
        .ant-table-tbody > tr > td:nth-child(2) {
            padding: 10px 0;
        }
    }
    .price-modal{
        width: 520px !important;
        height: 350px !important;
    }
</style>
<style scoped lang="scss">
    .dis-input{
        width: 150px;
    }
.page-container-height{
    background-color: #fff;
    .price-title{
        color: #333333;
        font-size: 22px;
        font-weight: 700;
        padding: 40px 0 40px 69px;
    }
    .table-name,.table-name1{
        cursor: pointer;
      color: #387BFC;
        font-size: 14px;
    }
    .table-name1{
        margin-left: 26px;
    }
}
</style>
